<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { BILLING_CYCLE } from '@/common/constants';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypesForMeeting } from '@/views/config/addon-cards/index.vue';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
import { get, orderBy } from 'lodash';
import { planTypes } from "@/common/constants";

export default {
  name: 'WebinarAddon',
  mixins: [base, planCommon, addonCustomSelect],
  data(){
    return {
      form: {
        selectedNumber: 1,
        billingCycle: BILLING_CYCLE.MONTHLY
      },
    };
  },
  for: ()=> {
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      return planTypesForMeeting();
  },
  computed: {
    currentProductPlans() {
      return orderBy(
        this.planMapFlat.filter((p) => p.type === planTypes.WEBINAR && !p.isOneMonth),
        ['participants', 'amount'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
};
</script>
